
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import moment from 'moment';
import { schedule10DataInfoType } from '@/types/Application/FamilyLawMatter/Pdf';
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import FormPart from '@/components/utils/PopulateForms/components/FormPart.vue';
import NoteBox from '@/components/utils/PopulateForms/components/NoteBox.vue';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        GreyBoxForm,
        ScheduleHeader,
        FormPart,
        NoteBox
    }
})
export default class Schedule10 extends Vue {

    @Prop({required:true})
    result!: any; 
  
    dataReady = false;    
    exSpsSupInfo = {} as schedule10DataInfoType;
   
    mounted(){
        this.dataReady = false;       
        this.extractInfo();       
        this.dataReady = true;       
    }

    public extractInfo(){        
        this.exSpsSupInfo = this.getExistingSpousalSupportInfo();
    }

    public getExistingSpousalSupportInfo(){        

        let existingSpousalSupportInfo = {} as schedule10DataInfoType

        if (this.result.existingSpousalSupportOrderAgreementSurvey){
            existingSpousalSupportInfo.current = {
                date: '',
                order: this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingOrder',
                agreement: this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingAgreement',
                directors: this.result.existingSpousalSupportOrderAgreementSurvey.filedWithDirector == 'y',
                reviewable: this.result.existingSpousalSupportOrderAgreementSurvey.reviewableTerm == 'y',
                fillForm: this.result.existingSpousalSupportOrderAgreementSurvey.fillOutForm == 'completeNow',
                description: ''
            }

            if (this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingOrder'                
                && this.result.existingSpousalSupportFinalOrderSurvey?.orderDate){
                    existingSpousalSupportInfo.current.date = Vue.filter('beautify-date')(this.result.existingSpousalSupportFinalOrderSurvey.orderDate);
            }

            if (this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingAgreement'               
                && this.result.existingSpousalSupportAgreementSurvey?.agreementDate){                    
                    existingSpousalSupportInfo.current.date = Vue.filter('beautify-date')(this.result.existingSpousalSupportAgreementSurvey.agreementDate);
            }

        }

        if ( this.result.existingSpousalSupportOrderAgreementSurvey?.existingType == 'ExistingAgreement' && this.result.existingSpousalSupportAgreementSurvey){
            existingSpousalSupportInfo.agreementInfo = {                
                replace: this.result.existingSpousalSupportAgreementSurvey.agreementDifferenceType == 'replacedAgreement',
                setAside: this.result.existingSpousalSupportAgreementSurvey.agreementDifferenceType == 'setAsideAgreement',
                reason: this.result.existingSpousalSupportAgreementSurvey.changesReasoning
            }
        } else {
            existingSpousalSupportInfo.agreementInfo = {                
                replace: false,
                setAside: false,
                reason: ''
            }
        }

        if (this.result.existingSpousalSupportOrderAgreementSurvey?.existingType == 'ExistingOrder' && this.result.existingSpousalSupportFinalOrderSurvey){
            const changesSinceOrderList = this.result.existingSpousalSupportFinalOrderSurvey.changesSinceOrderList
            const orderChangeList = (changesSinceOrderList?.checked?.length>0)? changesSinceOrderList.checked:[];
            
            existingSpousalSupportInfo.orderInfo = {

                changes: {
                    myfin: orderChangeList.includes('myFinancialChanged'),
                    opfin: orderChangeList.includes('partyFinancialChanged'),
                    myEmp: orderChangeList.includes('myEmploymentChanged'),
                    opEmp: orderChangeList.includes('partyEmploymentChanged'),
                    houseHold: orderChangeList.includes('myHouseholdChanged'),
                    newInfo: orderChangeList.includes('newInformation'),                    
                    other: orderChangeList.includes('other')
                },

                newInfo:     (this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingOrder' &&  orderChangeList.includes('newInformation')         && changesSinceOrderList && changesSinceOrderList.newInformationComment)?         changesSinceOrderList.newInformationComment:'',
                houseHold:   (this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingOrder' &&  orderChangeList.includes('myHouseholdChanged')     && changesSinceOrderList && changesSinceOrderList.myHouseholdChangedComment)?     changesSinceOrderList.myHouseholdChangedComment:'',
                myEmp:       (this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingOrder' &&  orderChangeList.includes('myEmploymentChanged')    && changesSinceOrderList && changesSinceOrderList.myEmploymentChangedComment)?    changesSinceOrderList.myEmploymentChangedComment:'',
                opEmp:       (this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingOrder' &&  orderChangeList.includes('partyEmploymentChanged') && changesSinceOrderList && changesSinceOrderList.partyEmploymentChangedComment)? changesSinceOrderList.partyEmploymentChangedComment:'',
                otherChange: (this.result.existingSpousalSupportOrderAgreementSurvey.existingType == 'ExistingOrder' &&  orderChangeList.includes('other')                  && changesSinceOrderList && changesSinceOrderList.otherComment)?                  changesSinceOrderList.otherComment:'',
                
                change: this.result.existingSpousalSupportFinalOrderSurvey.orderDifferenceType == 'changeOrder',
                cancel: this.result.existingSpousalSupportFinalOrderSurvey.orderDifferenceType != 'changeOrder'             
                
            }
        } else {
            existingSpousalSupportInfo.orderInfo = {

                changes: {
                    myfin: false,
                    opfin: false,
                    myEmp: false,
                    opEmp: false,
                    houseHold: false,
                    newInfo: false,                   
                    other: false
                },

                newInfo:     '',
                houseHold:   '',
                myEmp:       '',
                opEmp:       '',
                otherChange: '',
                change: false,
                cancel: false
            }
        }

        if (this.result.aboutExistingSpousalSupportOrderSurvey){
            const changeOrReplaceCondition = ((this.result.existingSpousalSupportOrderAgreementSurvey?.existingType == 'ExistingOrder'     && this.result.existingSpousalSupportFinalOrderSurvey?.orderDifferenceType == 'changeOrder') ||
                                              (this.result.existingSpousalSupportOrderAgreementSurvey?.existingType == 'ExistingAgreement' && this.result.existingSpousalSupportAgreementSurvey?.agreementDifferenceType == 'replacedAgreement'));
               
            existingSpousalSupportInfo.about = {
                chSinceOrder: changeOrReplaceCondition? this.result.aboutExistingSpousalSupportOrderSurvey.changesSinceOrder:''
            }
        } else {
            existingSpousalSupportInfo.about = {
                chSinceOrder: ''
            }
        }       

        if (this.result.unpaidSpousalSupportSurvey){  
            
            const paymentSchedule = this.result.unpaidSpousalSupportSurvey.paymentSchedule
            existingSpousalSupportInfo.payDetails = this.result.unpaidSpousalSupportSurvey.unpaid == "y"?
            {
                currentDate: moment().format("MMM DD, yyyy"),
                unpaid:true ,
                unPaidAmount: this.result.unpaidSpousalSupportSurvey.unPaidAmount,
                reduce:       this.result.unpaidSpousalSupportSurvey.applyToReduce =="y"? true : false,
                reduceAmount: this.result.unpaidSpousalSupportSurvey.applyToReduce =="y"? this.result.unpaidSpousalSupportSurvey.reduceAmount:'',
                reduceReason: this.result.unpaidSpousalSupportSurvey.applyToReduce =="y"? this.result.unpaidSpousalSupportSurvey.whyReduceAmount:'',
                monthly:   paymentSchedule? paymentSchedule.selected == 'monthly':false,                
                rate:      paymentSchedule?.selected == 'monthly'? paymentSchedule.monthlyAmount:'',
                lumpSum:   paymentSchedule? paymentSchedule.selected == 'Lump Sum':false,                
                other:     paymentSchedule? paymentSchedule.selected == 'other':false,
                otherComm: paymentSchedule? paymentSchedule.otherComment: ''
            }:{
                currentDate:moment().format("MMM DD, yyyy"),
                unpaid: false,
                unPaidAmount: '0',
                reduce: false,
                reduceAmount: '',
                reduceReason: '',
                monthly: false,                
                rate: '',
                lumpSum: false,                
                other: false,
                otherComm: ''
            }
        }

        if (this.result.calculatingSpousalSupportSurvey){
            existingSpousalSupportInfo.calc = {
                attaching: this.result.calculatingSpousalSupportSurvey?.attachingCalculations == 'y',
                reason: ( this.result.calculatingSpousalSupportSurvey?.attachingCalculations == 'n'
                        && this.result.calculatingSpousalSupportSurvey.whyNotAttachingCalculations)? this.result.calculatingSpousalSupportSurvey.whyNotAttachingCalculations:''
            }
        }

        let form4unable = false;

        if(this.result.flmAdditionalDocumentsSurvey?.unableFileForms){
            for(const form of this.result.flmAdditionalDocumentsSurvey.unableFileForms){
                if(form.includes("Financial Statement Form 4")){
                    form4unable = true;
                }
            }   
        }

        if(this.result.flmAdditionalDocumentsSurvey?.isFilingAdditionalDocs=='n' && form4unable){
            existingSpousalSupportInfo.applyForCaseManagement = true           
        }       

        return existingSpousalSupportInfo;
    }   
}
